import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usersApi } from '../services/api';
import './UsersManagement.css';

function UsersManagement({ user }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      // Get organization ID from logged-in user
      console.log('User object:', user);
      console.log('User profile:', user?.profile);

      // Try multiple possible field names
      const organizationId =
        user?.profile?.organisationId ||
        user?.profile?.organizationId ||
        user?.profile?.subscriptionId ||
        user?.profile?.subscription_id ||
        user?.organisationId ||
        user?.organizationId ||
        // Fallback to actual organization ID from database
        'df51816f-d87a-46df-97be-a5aa49e34fb6';

      console.log('Using organization ID:', organizationId);

      const data = await usersApi.getAll(organizationId);
      setUsers(data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching users:', err);
      console.error('User object was:', user);
    } finally {
      setLoading(false);
    }
  };

  const getInitials = (firstName, lastName) => {
    if (!firstName && !lastName) return '?';
    const firstInitial = firstName ? firstName[0] : '';
    const lastInitial = lastName ? lastName[0] : '';
    return (firstInitial + lastInitial).toUpperCase();
  };

  const filteredUsers = users.filter(u => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    const fullName = `${u.firstName || ''} ${u.lastName || ''}`.toLowerCase();
    const email = (u.emailAddress || '').toLowerCase();
    return fullName.includes(query) || email.includes(query) || (u.role || '').toLowerCase().includes(query);
  });

  if (loading) {
    return (
      <div className="users-management-container">
        <div className="loading">Loading users...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="users-management-container">
        <div className="error-message">Error: {error}</div>
        <button onClick={fetchUsers} className="btn btn-primary">
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="users-management-container">
      <div className="page-header">
        <div>
          <h1>People Management</h1>
          <p className="subtitle">Discover and connect with talented individuals in your organization</p>
        </div>
        <Link to="/users/new" className="btn btn-primary">
          + Add New User
        </Link>
      </div>

      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name, email, or role..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {filteredUsers.length === 0 ? (
        <div className="empty-state">
          <p>No users found</p>
          {searchQuery && (
            <button onClick={() => setSearchQuery('')} className="btn btn-secondary">
              Clear Search
            </button>
          )}
        </div>
      ) : (
        <div className="users-grid">
          {filteredUsers.map(u => (
            <Link key={u.id} to={`/users/${u.id}`} className="user-card">
              <div className="user-card-header">
                <div className="avatar">
                  {getInitials(u.firstName, u.lastName)}
                </div>
                <div className="user-info">
                  <h3>{u.firstName} {u.lastName}</h3>
                  <p className="user-email">{u.emailAddress}</p>
                </div>
              </div>
              <div className="user-card-body">
                {u.role && (
                  <div className="user-detail">
                    <span className="label">Role:</span>
                    <span className="value">{u.role}</span>
                  </div>
                )}
                {u.status && (
                  <div className="user-detail">
                    <span className="label">Status:</span>
                    <span className={`badge status-${u.status.toLowerCase()}`}>{u.status}</span>
                  </div>
                )}
                <div className="user-detail">
                  <span className="label">Last Sign In:</span>
                  <span className="value">
                    {new Date(u.lastSignedIn).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      <div className="users-count">
        Showing {filteredUsers.length} of {users.length} users
      </div>
    </div>
  );
}

export default UsersManagement;
